(() => {
  'use strict';

  const DESCRIPTION_SELECTOR = '[data-collection-description], .subcollections-featured-collection__description.rte';
  const PRODUCT_LINK_SELECTOR = '.productitem--title a[href*="/products/"]';
  const MAX_PAGES = 30;

  const normalize = (value) =>
    (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase();

  const directProductPath = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? `/products/${match[1]}` : `${url.pathname}${url.search}${url.hash}`;
    } catch (_) {
      return href;
    }
  };

  const collectProducts = (doc, products) => {
    doc.querySelectorAll(PRODUCT_LINK_SELECTOR).forEach((link) => {
      const key = normalize(link.textContent);
      const href = link.getAttribute('href');
      if (key && href && !products.has(key)) {
        products.set(key, directProductPath(href));
      }
    });
  };

  const linkDescriptionItems = (products) => {
    let unresolved = 0;

    document.querySelectorAll(DESCRIPTION_SELECTOR).forEach((description) => {
      description.querySelectorAll('li').forEach((item) => {
        if (item.querySelector('a')) return;

        const key = normalize(item.textContent);
        if (!key) return;

        const href = products.get(key);
        if (!href) {
          unresolved += 1;
          return;
        }

        const anchor = document.createElement('a');
        anchor.href = href;
        anchor.className = 'si-collection-product-link';
        while (item.firstChild) anchor.appendChild(item.firstChild);
        item.appendChild(anchor);
      });
    });

    return unresolved;
  };

  const paginationUrls = (doc) => {
    const urls = new Set();

    doc.querySelectorAll('a[href*="page="]').forEach((link) => {
      try {
        const url = new URL(link.getAttribute('href'), window.location.href);
        const page = Number(url.searchParams.get('page'));
        if (
          url.origin === window.location.origin &&
          url.pathname === window.location.pathname &&
          Number.isFinite(page) &&
          page > 0
        ) {
          urls.add(url.href);
        }
      } catch (_) {}
    });

    return Array.from(urls);
  };

  const init = async () => {
    if (!document.querySelector(DESCRIPTION_SELECTOR)) return;

    const products = new Map();
    collectProducts(document, products);

    let unresolved = linkDescriptionItems(products);
    if (!unresolved) return;

    const visited = new Set([window.location.href]);
    const queue = paginationUrls(document);

    while (queue.length && visited.size <= MAX_PAGES && unresolved) {
      const href = queue.shift();
      if (!href || visited.has(href)) continue;
      visited.add(href);

      try {
        const response = await fetch(href, { credentials: 'same-origin' });
        if (!response.ok) continue;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        collectProducts(doc, products);

        paginationUrls(doc).forEach((pageUrl) => {
          if (!visited.has(pageUrl) && !queue.includes(pageUrl)) queue.push(pageUrl);
        });

        unresolved = linkDescriptionItems(products);
      } catch (_) {}
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();